/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ExportDocumentsBuildImageInputFile$Params {
  mId?: string | null;
  Type?: string | null;
  FileType?: string | null;
}

export function exportDocumentsBuildImageInputFile(http: HttpClient, rootUrl: string, params?: ExportDocumentsBuildImageInputFile$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, exportDocumentsBuildImageInputFile.PATH, 'get');
  if (params) {
    rb.query('mId', params.mId, {});
    rb.query('Type', params.Type, {});
    rb.query('FileType', params.FileType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

exportDocumentsBuildImageInputFile.PATH = '/api/ExportDocuments';
